import { Core4MetricAverage } from '../../../model/Entities';
import {
    baseballCore4Age910,
    baseballCore4Age1112,
    baseballCore4Age1314,
    baseballCore4Age1516,
    baseballCore4Age1718,
    baseballCore4AgeCollege,
    baseballCore4AgePro,
} from './PlayerCore4BaseballAges';
import {
    baseballCore4Metric10YD,
    baseballCore4Metric30YD,
    baseballCore4Metric5105,
    baseballCore4MetricBatSpeed,
    baseballCore4MetricExitVelocity,
    baseballCore4MetricFastballPitching,
    baseballCore4MetricHandGripLT,
    baseballCore4MetricHandGripRT,
    baseballCore4MetricPeakHandSpeed,
    baseballCore4MetricPositionThrowVelocity,
    baseballCore4MetricTimeToContact,
    baseballCore4MetricVerticalJump,
} from './PlayerCore4BaseballMetrics';

export const baseballCore4Averages: Core4MetricAverage[] = [
    // HITTING

    { age: baseballCore4Age910, metric: baseballCore4MetricExitVelocity, gender: 'Male', average: 50 },
    { age: baseballCore4Age910, metric: baseballCore4MetricBatSpeed, gender: 'Male', average: 48 },
    { age: baseballCore4Age910, metric: baseballCore4MetricPeakHandSpeed, gender: 'Male', average: 18 },
    { age: baseballCore4Age910, metric: baseballCore4MetricTimeToContact, gender: 'Male', average: 0.22 },

    { age: baseballCore4Age1112, metric: baseballCore4MetricExitVelocity, gender: 'Male', average: 55 },
    { age: baseballCore4Age1112, metric: baseballCore4MetricBatSpeed, gender: 'Male', average: 48 },
    { age: baseballCore4Age1112, metric: baseballCore4MetricPeakHandSpeed, gender: 'Male', average: 20 },
    { age: baseballCore4Age1112, metric: baseballCore4MetricTimeToContact, gender: 'Male', average: 0.2 },

    { age: baseballCore4Age1314, metric: baseballCore4MetricExitVelocity, gender: 'Male', average: 68 },
    { age: baseballCore4Age1314, metric: baseballCore4MetricBatSpeed, gender: 'Male', average: 55 },
    { age: baseballCore4Age1314, metric: baseballCore4MetricPeakHandSpeed, gender: 'Male', average: 21 },
    { age: baseballCore4Age1314, metric: baseballCore4MetricTimeToContact, gender: 'Male', average: 0.18 },

    { age: baseballCore4Age1516, metric: baseballCore4MetricExitVelocity, gender: 'Male', average: 78 },
    { age: baseballCore4Age1516, metric: baseballCore4MetricBatSpeed, gender: 'Male', average: 65 },
    { age: baseballCore4Age1516, metric: baseballCore4MetricPeakHandSpeed, gender: 'Male', average: 23 },
    { age: baseballCore4Age1516, metric: baseballCore4MetricTimeToContact, gender: 'Male', average: 0.17 },

    { age: baseballCore4Age1718, metric: baseballCore4MetricExitVelocity, gender: 'Male', average: 85 },
    { age: baseballCore4Age1718, metric: baseballCore4MetricBatSpeed, gender: 'Male', average: 68 },
    { age: baseballCore4Age1718, metric: baseballCore4MetricPeakHandSpeed, gender: 'Male', average: 23 },
    { age: baseballCore4Age1718, metric: baseballCore4MetricTimeToContact, gender: 'Male', average: 0.16 },

    { age: baseballCore4AgeCollege, metric: baseballCore4MetricExitVelocity, gender: 'Male', average: 90 },
    { age: baseballCore4AgeCollege, metric: baseballCore4MetricBatSpeed, gender: 'Male', average: 75 },
    { age: baseballCore4AgeCollege, metric: baseballCore4MetricPeakHandSpeed, gender: 'Male', average: 24 },
    { age: baseballCore4AgeCollege, metric: baseballCore4MetricTimeToContact, gender: 'Male', average: 0.16 },

    { age: baseballCore4AgePro, metric: baseballCore4MetricExitVelocity, gender: 'Male', average: 95 },
    { age: baseballCore4AgePro, metric: baseballCore4MetricBatSpeed, gender: 'Male', average: 85 },
    { age: baseballCore4AgePro, metric: baseballCore4MetricPeakHandSpeed, gender: 'Male', average: 26 },
    { age: baseballCore4AgePro, metric: baseballCore4MetricTimeToContact, gender: 'Male', average: 0.15 },

    // ARM VELOCITY

    { age: baseballCore4Age910, metric: baseballCore4MetricFastballPitching, gender: 'Male', average: 45 },
    { age: baseballCore4Age910, metric: baseballCore4MetricPositionThrowVelocity, gender: 'Male', average: 50 },

    { age: baseballCore4Age1112, metric: baseballCore4MetricFastballPitching, gender: 'Male', average: 55 },
    { age: baseballCore4Age1112, metric: baseballCore4MetricPositionThrowVelocity, gender: 'Male', average: 55 },

    { age: baseballCore4Age1314, metric: baseballCore4MetricFastballPitching, gender: 'Male', average: 65 },
    { age: baseballCore4Age1314, metric: baseballCore4MetricPositionThrowVelocity, gender: 'Male', average: 60 },

    { age: baseballCore4Age1516, metric: baseballCore4MetricFastballPitching, gender: 'Male', average: 75 },
    { age: baseballCore4Age1516, metric: baseballCore4MetricPositionThrowVelocity, gender: 'Male', average: 70 },

    { age: baseballCore4Age1718, metric: baseballCore4MetricFastballPitching, gender: 'Male', average: 80 },
    { age: baseballCore4Age1718, metric: baseballCore4MetricPositionThrowVelocity, gender: 'Male', average: 80 },

    { age: baseballCore4AgeCollege, metric: baseballCore4MetricFastballPitching, gender: 'Male', average: 88 },
    { age: baseballCore4AgeCollege, metric: baseballCore4MetricPositionThrowVelocity, gender: 'Male', average: 87.5 },

    { age: baseballCore4AgePro, metric: baseballCore4MetricFastballPitching, gender: 'Male', average: 94 },
    { age: baseballCore4AgePro, metric: baseballCore4MetricPositionThrowVelocity, gender: 'Male', average: 92.5 },

    // SPEED & AGILITY

    { age: baseballCore4Age910, metric: baseballCore4Metric10YD, gender: 'Male', average: 2.05 },
    { age: baseballCore4Age910, metric: baseballCore4Metric30YD, gender: 'Male', average: 5.15 },
    { age: baseballCore4Age910, metric: baseballCore4Metric5105, gender: 'Male', average: 5.75 },

    { age: baseballCore4Age1112, metric: baseballCore4Metric10YD, gender: 'Male', average: 2.0 },
    { age: baseballCore4Age1112, metric: baseballCore4Metric30YD, gender: 'Male', average: 4.9 },
    { age: baseballCore4Age1112, metric: baseballCore4Metric5105, gender: 'Male', average: 5.5 },

    { age: baseballCore4Age1314, metric: baseballCore4Metric10YD, gender: 'Male', average: 1.9 },
    { age: baseballCore4Age1314, metric: baseballCore4Metric30YD, gender: 'Male', average: 4.6 },
    { age: baseballCore4Age1314, metric: baseballCore4Metric5105, gender: 'Male', average: 5.2 },

    { age: baseballCore4Age1516, metric: baseballCore4Metric10YD, gender: 'Male', average: 1.8 },
    { age: baseballCore4Age1516, metric: baseballCore4Metric30YD, gender: 'Male', average: 4.3 },
    { age: baseballCore4Age1516, metric: baseballCore4Metric5105, gender: 'Male', average: 4.9 },

    { age: baseballCore4Age1718, metric: baseballCore4Metric10YD, gender: 'Male', average: 1.75 },
    { age: baseballCore4Age1718, metric: baseballCore4Metric30YD, gender: 'Male', average: 4.1 },
    { age: baseballCore4Age1718, metric: baseballCore4Metric5105, gender: 'Male', average: 4.7 },

    { age: baseballCore4AgeCollege, metric: baseballCore4Metric10YD, gender: 'Male', average: 1.7 },
    { age: baseballCore4AgeCollege, metric: baseballCore4Metric30YD, gender: 'Male', average: 3.9 },
    { age: baseballCore4AgeCollege, metric: baseballCore4Metric5105, gender: 'Male', average: 4.5 },

    { age: baseballCore4AgePro, metric: baseballCore4Metric10YD, gender: 'Male', average: 1.65 },
    { age: baseballCore4AgePro, metric: baseballCore4Metric30YD, gender: 'Male', average: 3.8 },
    { age: baseballCore4AgePro, metric: baseballCore4Metric5105, gender: 'Male', average: 4.4 },

    // STRENGTH

    { age: baseballCore4Age910, metric: baseballCore4MetricVerticalJump, gender: 'Male', average: 14 },
    { age: baseballCore4Age910, metric: baseballCore4MetricHandGripRT, gender: 'Male', average: 40 },
    { age: baseballCore4Age910, metric: baseballCore4MetricHandGripLT, gender: 'Male', average: 40 },

    { age: baseballCore4Age1112, metric: baseballCore4MetricVerticalJump, gender: 'Male', average: 16 },
    { age: baseballCore4Age1112, metric: baseballCore4MetricHandGripRT, gender: 'Male', average: 50 },
    { age: baseballCore4Age1112, metric: baseballCore4MetricHandGripLT, gender: 'Male', average: 50 },

    { age: baseballCore4Age1314, metric: baseballCore4MetricVerticalJump, gender: 'Male', average: 18 },
    { age: baseballCore4Age1314, metric: baseballCore4MetricHandGripRT, gender: 'Male', average: 65 },
    { age: baseballCore4Age1314, metric: baseballCore4MetricHandGripLT, gender: 'Male', average: 65 },

    { age: baseballCore4Age1516, metric: baseballCore4MetricVerticalJump, gender: 'Male', average: 20 },
    { age: baseballCore4Age1516, metric: baseballCore4MetricHandGripRT, gender: 'Male', average: 85 },
    { age: baseballCore4Age1516, metric: baseballCore4MetricHandGripLT, gender: 'Male', average: 85 },

    { age: baseballCore4Age1718, metric: baseballCore4MetricVerticalJump, gender: 'Male', average: 22 },
    { age: baseballCore4Age1718, metric: baseballCore4MetricHandGripRT, gender: 'Male', average: 95 },
    { age: baseballCore4Age1718, metric: baseballCore4MetricHandGripLT, gender: 'Male', average: 95 },

    { age: baseballCore4AgeCollege, metric: baseballCore4MetricVerticalJump, gender: 'Male', average: 28 },
    { age: baseballCore4AgeCollege, metric: baseballCore4MetricHandGripRT, gender: 'Male', average: 105 },
    { age: baseballCore4AgeCollege, metric: baseballCore4MetricHandGripLT, gender: 'Male', average: 105 },

    { age: baseballCore4AgePro, metric: baseballCore4MetricVerticalJump, gender: 'Male', average: 30 },
    { age: baseballCore4AgePro, metric: baseballCore4MetricHandGripRT, gender: 'Male', average: 125 },
    { age: baseballCore4AgePro, metric: baseballCore4MetricHandGripLT, gender: 'Male', average: 125 },
];
